import React, { useState, useEffect } from 'react';
import { KTIcon, toAbsoluteUrl } from '../../../helpers';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import clsx from 'clsx';
import DatePicker from 'react-datepicker';
import { get_all_attendance_feed } from '../api/widgetApi';
import { formatDatePickr, formatDateWithoutTime } from '../../../../app/helper-functions/DateFunction';
import { AttendanceFeed } from '../../../../app/modules/accounts/components/settings/SettingsModel';

type Props = {
  className: string;
};

const AttendanceFeedWidget: React.FC<Props> = ({ className }) => {
  const [listingData, setListingData] = useState<AttendanceFeed[]>([]);
  const currentStartDate = new Date();
  const currentYear = currentStartDate.getFullYear();
  const lastDayOfCurrentMonth = new Date(currentStartDate.getFullYear(), currentStartDate.getMonth() + 1, 0);

  const [startDate, setStartDate] = useState<string | null>(formatDatePickr(currentStartDate));
  const [endDate, setEndDate] = useState<string | null>(formatDatePickr(lastDayOfCurrentMonth));

  const { data: filterData, refetch: filterDataAttendanceFeed } = useQuery(
    'filterDataAttendanceFeed',
    () => get_all_attendance_feed(),
    {
      onSuccess: (filteredData) => {
        setListingData(filteredData?.data || []);
      },
      onError: (error: any) => {
        if (error.response) {
          toast.error('Failed to fetch Feed.');
        }
      },
      enabled: true,
      refetchOnWindowFocus: true,
    }
  );

  const handleApplyFilters = () => {
    filterDataAttendanceFeed();
  };

  // const handleClearFilters = () => {
  //   setStartDate(null);
  //   setEndDate(null);
  //   setListingData([]);
  // };

  useEffect(() => {
    if (filterData?.data) {
      setListingData(filterData.data || []);
    }
  }, [filterData]);

  return (
    <div className={clsx('card', className)}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>Attendance Feed</span>
        </h3>
        {/* <div className='card-toolbar'>
          <div className='d-flex'>
            <DatePicker
              selected={startDate ? new Date(startDate) : null}
              onChange={(date) => setStartDate(date ? formatDatePickr(date) : null)}
              placeholderText='From Date'
              className='form-control'
              dateFormat='dd-MM-yyyy'
              isClearable
              minDate={new Date()}
            />
            <DatePicker
              selected={endDate ? new Date(endDate) : null}
              onChange={(date) => setEndDate(date ? formatDatePickr(date) : null)}
              placeholderText='To Date'
              className='form-control ms-2'
              dateFormat='dd-MM-yyyy'
              isClearable
              minDate={startDate ? new Date(startDate) : new Date()}
            />
            <button className='btn btn-primary ms-3' onClick={handleApplyFilters} title="Apply Filter">
              <i className="fa fa-filter"></i>
            </button>
            <button className='btn btn-secondary ms-2' onClick={handleClearFilters} title="Clear Filter">
              Clear
            </button>
          </div>
        </div> */}
      </div>
      <div className='card-body pt-5'>
        {listingData?.length > 0 ? (
          <div>
            {/* Column Headers */}
            <div className='d-flex align-items-center mb-3 fw-bold text-gray-600'>
              <div className='symbol symbol-50px me-5' />
              <div className='flex-grow-1 me-2'>Employee Name</div>
              <div className='flex-grow-1 me-2'>Last Activity</div>
              <div className='flex-grow-1 me-2'>Total Shift Duration</div>
              <div className='flex-grow-1 me-2'>Activity Date</div>
            </div>

            {listingData.map((listData, index) => {
              const name = listData?.employee_name || 'No Name'
              const profileUrl = listData?.profile_picture
              const firstLetter = name.charAt(0).toUpperCase()

              return (
                <div key={index} className='d-flex align-items-sm-center mb-6'>
                  <div className='symbol symbol-50px me-5'>
                    <span className='symbol-label bg-light-primary text-primary fw-bold fs-3 d-flex justify-content-center align-items-center'>
                      {profileUrl ? (
                        <img
                          src={profileUrl}
                          className='h-50 align-self-center'
                          alt='profile'
                        />
                      ) : (
                        firstLetter
                      )}
                    </span>
                  </div>
                  <div className='flex-grow-1 me-2'>
                    <span className='text-gray-800 fw-semibold'>{name}</span>
                  </div>
                  <div className='flex-grow-1 me-2'>
                    <span className='text-muted fs-7'>{listData?.last_activity || 'No Recent Activity'}</span>
                  </div>
                  <div className='flex-grow-1 me-2 d-flex align-items-center'>
                    <i className='fa fa-clock text-gray-500 me-1'></i>
                    <span className='text-muted fs-7'>{listData?.total_shift_duration || 'N/A'}</span>
                  </div>
                  <div className='flex-grow-1 me-2'>
                    <span className='badge badge-light fw-bold'>
                      {formatDateWithoutTime(listData?.last_activity_time)}
                    </span>
                  </div>
                </div>
              )
            })}
          </div>
        ) : (
          <div className="d-flex align-items-sm-center justify-content-center text-center">
            <div className="symbol symbol-150px me-5">
              <span className="symbol-label d-flex justify-content-center align-items-center">
                <img
                  src={toAbsoluteUrl('/media/svg/general/gift-boxes.png')}
                  className="h-50 align-self-center"
                  alt="No Attendance Feed found."
                />
              </span>
            </div>
            <span className="text-muted fw-bold fs-6 mt-2">No Attendance Feed Found.</span>
          </div>
        )}
      </div>

    </div>
  );
};

export { AttendanceFeedWidget };